import apiClientFc from "@/shared/api/apiClientFc";
import { showAlert } from "@/shared/store/alertStore";
import i18n from "@/shared/config/i18n";

function notifyFc(data, successMessage) {
  if (!data) return;
  if (data.status === false) {
    showAlert(
      i18n.global.t("Ошибка"),
      data.detail || i18n.global.t("Не удалось выполнить операцию"),
      "error"
    );
    return;
  }
  if (successMessage) {
    showAlert(data.detail || i18n.global.t(successMessage), "", "success");
  }
}

export const listFaces = async ({
  limit = 100,
  offset = 0,
  personName,
} = {}) => {
  const params = { limit, offset };
  if (personName) params.person_name = personName;
  const { data } = await apiClientFc.get("/faces", {
    params,
    metaData: { isNotificationDisabled: true },
  });
  return data;
};

export const listPersonHistory = async (
  personId,
  { status, limit = 20, offset = 0 } = {}
) => {
  const params = { limit, offset };
  if (status) params.status = status;
  const { data } = await apiClientFc.get(`/persons/${personId}/history`, {
    params,
    metaData: { isNotificationDisabled: true },
  });
  return data;
};

export const listAuditHistory = async ({
  personId,
  action,
  status,
  startTime,
  endTime,
  sortBy = "timestamp",
  sortOrder = "desc",
  limit = 100,
  offset = 0,
} = {}) => {
  const params = { sort_by: sortBy, sort_order: sortOrder, limit, offset };
  if (personId) params.person_id = personId;
  if (action) params.action = action;
  if (status) params.status = status;
  if (startTime) params.start_time = startTime;
  if (endTime) params.end_time = endTime;
  const { data } = await apiClientFc.get("/audit/history", {
    params,
    metaData: { isNotificationDisabled: true },
  });
  return data;
};

export const checkFacesExists = async (personId) => {
  const { data } = await apiClientFc.get(`/persons/${personId}/faces/exists`, {
    metaData: { isNotificationDisabled: true },
  });
  return data;
};

export const listPersonImages = async (personId, params = {}) => {
  const { data } = await apiClientFc.get(`/persons/${personId}/images`, {
    params,
    metaData: { isNotificationDisabled: true },
  });
  return data;
};

export const enrollPerson = async ({ personId, personName, files }) => {
  const formData = new FormData();
  formData.append("person_id", personId);
  formData.append("person_name", personName);
  files.forEach((file) => formData.append("files", file));
  const { data } = await apiClientFc.post("/enroll", formData, {
    metaData: { isNotificationDisabled: true },
  });
  notifyFc(data, "Face ID успешно создан");
  return data;
};

export const addFacesToPerson = async (personId, files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));
  const { data } = await apiClientFc.post(
    `/persons/${personId}/faces`,
    formData,
    { metaData: { isNotificationDisabled: true } }
  );
  notifyFc(data, "Фото добавлено");
  return data;
};

export const deletePersonAllFaces = async (personId) => {
  const { data } = await apiClientFc.delete(`/persons/${personId}/faces`, {
    metaData: { isNotificationDisabled: true },
  });
  notifyFc(data, "Face ID удалён");
  return data;
};

export const deleteFace = async (faceId) => {
  const { data } = await apiClientFc.delete(`/faces/${faceId}`, {
    metaData: { isNotificationDisabled: true },
  });
  notifyFc(data, "Фото удалено");
  return data;
};

export const fetchImage = async (objectName) => {
  const { data } = await apiClientFc.get(`/images/${objectName}`, {
    metaData: { isNotificationDisabled: true },
  });
  return data;
};
